export const getters = {
  getSchedule: (state, getters) => {
    return state;
  }
};